import Api, {validToken} from 'services';

// ACTION TYPES
export const masterDataHasErrored = () => ({type: '[MASTERDATA] HAS_ERRORED'});
export const masterDataIsLoading = () => ({type: '[MASTERDATA] IS_LOADING'});
export const masterDataFetchSuccess = data => ({type: '[MASTERDATA] FETCH_SUCCESS', data});


export const masterDataBaseHasErrored = () => ({type: '[MASTERDATABASE] HAS_ERRORED'});
export const masterDataBaseIsLoading = () => ({type: '[MASTERDATABASE] IS_LOADING'});
export const masterDataBaseFetchSuccess = dataBase => ({type: '[MASTERDATABASE] FETCH_SUCCESS', dataBase});
export const masterDataBaseCountFetchSuccess = data => ({type: '[MASTERDATABASE] FETCH_SUCCESS_CONTADOR', data});





export const mdata_collections = () => async dispatch => {
  //  validToken();
    dispatch(masterDataIsLoading());
    await Api.MasterData.getCollections({})
        .then(data => dispatch(masterDataFetchSuccess(data)))
        .catch(() => dispatch(masterDataHasErrored()));
};

export const mdata_getBase = (params) => async dispatch => {
  ///  validToken();
    dispatch(masterDataBaseIsLoading());
    await Api.MasterData.getBase(params)
        .then(data => dispatch(masterDataBaseFetchSuccess(data)))
        .catch(() => dispatch(masterDataBaseHasErrored()));
};

export const mdata_getBaseCount = (params) => async dispatch => {
  //  validToken();
    dispatch(masterDataBaseIsLoading());
    await Api.MasterData.getBaseCount(params)
        .then(data => dispatch(masterDataBaseCountFetchSuccess(data)))
        .catch(() => dispatch(masterDataBaseHasErrored()));
};


